<eo-base-form-control
  [styleClass]="getStyleClass()"
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
>
  <textarea
    pInputTextarea
    attr.aria-describedby="{{ id }}-help"
    class="w-full {{ getInputStyleClass() }}"
    [id]="id"
    [tabindex]="getTabIndex()"
    [placeholder]="getPlaceholder()"
    [formControl]="getFormControl()"
    [rows]="getRows()"
    [cols]="getCols()"
    [maxlength]="getMaxlength()"
    [minlength]="getMinlength()"
    [readonly]="getReadonly()"
    [disabled]="getDisabled()"
    [pKeyFilter]="getPKeyFilter()"
    (change)="change.emit($event)"
    (focus)="focus.emit($event)"
    (blur)="blur.emit($event)"
  ></textarea>
  <button *ngIf="getShowClear()" type="button" (click)="clear()">
    Καθαρισμός
  </button>
</eo-base-form-control>
